var foreach = require('foreach');

module.exports = function map(arr, fn) {
  var newArr = [];
  foreach(arr, function(item, itemIndex) {
    newArr.push(fn(item, itemIndex, arr));
  });
  return newArr;
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/map.js
// module id = 24
// module chunks = 0